/*
 * @Author: liyaoshi liyaoshi@sohu-inc.com
 * @Date: 2024-06-19 18:12:32
 * @@Description: 文件描述
 */
import { getOdinData as getOdinDataRequest } from 'msfe-client-request'
import Util from '../../utils/util'
import MptcfeWapAd from "mptcfe-wap-ad";

const env =  Util.getEnvironment() // test pre prod
const domainMap = {
    'test': '//test-odin.sohu.com/odin',
    'pre': '//pre-odin.sohu.com/odin',
    'prod': '//odin.sohu.com/odin',
}
/**
 * @description 空广告上报
 * @param {*} data 
 */
const handleEmptyAdReport = (data) => {
    if(data?.adExt?.reportUrlList?.length){
        MptcfeWapAd?.handlerAdExt(data.adExt)
    }
}

/**
 * @description 统一的奥丁请求
 * @param {*} param 
 * @returns 
 */
export const getOdinData = async function (param) {
    if(!param) {
        console.log('奥丁请求未传参，请检查传参', param)
        return
    }
    const cfgs = window.cfgs || {}
    const path = '/api/a/blockdata'
    const mainContent = {
        productId: '',
        productType: '',
        secureScore: cfgs?.secureScore || 100,
        categoryId: cfgs?.channelId,
        authorId: cfgs?.authorId,
        articleId: cfgs?.newsId,
    }
    const opts = {
        env: env,
        url: domainMap[env] + path,
        mainContent,
        param,
        isBatch: param?.isBatch,
    }
    const result = await getOdinDataRequest(opts)
    handleEmptyAdReport(result)
    return result
}